export enum HomePageComponentNameEnum {
  HomepageComponent = 'HomepageComponent',
  ProductHomepageVisaComponent = 'ProductHomepageVisaComponent',
  ProductHomepageMastercardComponent = 'ProductHomepageMastercardComponent',
  GenericProductHomepageComponent = 'GenericProductHomepageComponent',
  DefaultHomepageComponent = 'DefaultHomepageComponent',
  ContentOutsideHomepageComponent = 'ContentOutsideHomepageComponent',
}
